<template>
  <div class="full-page-wrap">
    <div class="container">
      <div class="inner-page-wrap mt-5">
        <div class="about-us-banner-section position-relative">
          <div class="banner-core-hld position-relative">
            <div class="banner-img-hld">
              <img src="../assets/Images/landing/About_Us_Header_Picture.png" />
            </div>
            <div class="banner-text-hld">
              <h5>ABOUT</h5>
              <h3>Temasek Polytechnic</h3>
            </div>
          </div>
        </div>
        <div class="introduction-hld">
          <h3 class="common-head text-center">
            Introduction to Temasek Polytechnic
          </h3>
          <v-row>
            <v-col md="6" sm="6" cols="12">
              <div class="single-intro">
                <div class="intro-image">
                  <img src="../assets/Images/landing/history.jpg" />
                </div>
                <div class="intro-desc">
                  <h3>TP’s Corporate Profile</h3>
                  <p class="mb-2">
                    Established in 1990, Temasek Polytechnic (TP) is one of the
                    leading institutions of higher learning in Singapore.
                    Currently, it offers
                    <a
                      href="https://www.tp.edu.sg/schools-and-courses/students/all-diploma-courses.html"
                      target="_blank"
                      >36 full-time diploma courses</a
                    >
                    in the areas of applied science, business, design,
                    engineering, humanities & social sciences and informatics &
                    IT. It also offers
                    <a
                      href="https://www.tp.edu.sg/schools-and-courses/adult-learners/all-courses.html"
                      target="_blank"
                      >over 40 part-time courses</a
                    >, up to the advanced diploma level. TP students undergo a
                    holistic learning system that combines hands-on experience,
                    character education, and relevant life skills in an
                    enriching learning environment.
                  </p>
                  <p>
                    The Polytechnic has also infused global realities into its
                    programmes and cultivated a mindset in its stakeholder that
                    embraces socio-cultural diversity. These ensure that TP
                    graduates are ready for work or further studies, and to
                    contribute meaningfully to the community.
                  </p>
                </div>
              </div>
            </v-col>
            <v-col md="6" sm="6" cols="12">
              <div class="single-intro">
                <div class="intro-image">
                  <img src="../assets/Images/landing/mission.jpg" />
                </div>
                <div class="intro-desc">
                  <h3>Mission, Vision, Values</h3>
                  <p class="mb-2">
                    <strong>Mission:</strong> To prepare school-leavers and
                    working adults for a future of dynamic change, with relevant
                    knowledge, life-long skills, character, and a thirst for
                    continuous improvement.
                  </p>
                  <p class="mb-2">
                    <strong>Vision:</strong> To be a world-class institution in
                    the global education network, reputed for our programmes,
                    applied research, managerial excellence and innovative
                    corporate culture.
                  </p>
                  <p class="mb-0">
                    <strong style="font-size: 16px">Values: </strong>
                  </p>
                  <ul type="disc" style="padding-left: 24px !important">
                    <li>
                      Responsibility for the continued growth and success of
                      Temasek Polytechnic
                    </li>
                    <li>Respect for the dignity of the individual</li>
                    <li>Integrity of the highest order</li>
                    <li>Student-centredness</li>
                    <li>Future-orientation</li>
                  </ul>
                </div>
              </div>
            </v-col>
            <v-col md="6" sm="6" cols="12">
              <div class="single-intro">
                <div class="intro-image">
                  <img src="../assets/Images/landing/diploma.jpg" />
                </div>
                <div class="intro-desc">
                  <h3>Developing Global Mindset</h3>
                  <p class="mb-2">
                    Temasek Polytechnic aims to develop every student as a
                    “future-oriented creator, values-centred leader and lifelong
                    learner”. However, a student cannot be all that if they are
                    inward-looking and without an overview of the world in this
                    globalised society. Skills such as civic literacy and
                    citizenship, global and cultural awareness, and social
                    responsibilities are crucial to help students be part of the
                    global community and economy.
                  </p>
                  <p class="mb-2">
                    To help inculcate the mindset and skills among students, the
                    Polytechnic embarked on a Developing Global Mindset (DGM)
                    journey through the International Relations department.
                  </p>
                  <p>
                    The TP DGM framework takes a holistic approach and is
                    anchored on two key aspects: academic curriculum and
                    experiential learning. This framework is enhanced by the
                    Internationalisation Strategies that provide overseas
                    exposures, and is enabled by an extended international
                    network that TP built over the years.
                  </p>
                </div>
              </div>
            </v-col>
            <v-col md="6" sm="6" cols="12">
              <div class="single-intro">
                <div class="intro-image">
                  <img src="../assets/Images/landing/uneovc.jpg" />
                </div>
                <div class="intro-desc">
                  <h3>UNESCO-UNEVOC Network Member</h3>
                  <p class="mb-2">
                    Temasek Polytechnic has been a member of the UNESCO-UNEVOC
                    since 2019 and is the only UNEVOC centre in Singapore thus
                    far. The polytechnic’s membership in the network has enabled
                    it to stay well-informed of emerging trends in Technical and
                    Vocational Education and Training (TVET), thereby helping it
                    to better prepare our youths for future-oriented careers.
                  </p>
                  <p class="mb-2">
                    In April 2021, the Polytechnic had the privilege to
                    co-organise the Conference on Bridging Innovation and
                    Learning in TVET with UNESCO-UNEVOC. The polytechnic also
                    exchanged best practices on education and training in TVET
                    with other participating institutions at the conference.
                  </p>
                  <p class="mb-2">
                    With the support of UNESCO-UNEVOC, TP is proud to organise
                    and bring the WYSD celebration to the Asia-Pacific region –
                    the first ever celebration to be held at the regional level.
                  </p>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
        <!-- <div class="gallery-part">
          <v-row>
            <v-col md="6" sm="6" cols="12" class="p-2 pb-0">
              <div class="gallery-big">
                <img src="../assets/Images/landing/gallery1.jpg"/>
              </div>
            </v-col>
            <v-col md="3" sm="3" cols="12" class="p-2 pb-0">
              <div class="gallery-big">
                <img src="../assets/Images/landing/gallery2.jpg"/>
              </div>
            </v-col>
            <v-col md="3" sm="3" cols="12" class="p-2 pb-0">
              <div class="gallery-big">
              <img src="../assets/Images/landing/gallery3.jpg"/>
              </div>
            </v-col>
            <v-col md="3" sm="3" cols="12" class="p-2">
              <div class="gallery-big">
                <img src="../assets/Images/landing/gallery4.jpg"/>
              </div>
            </v-col>
            <v-col md="3" sm="3" cols="12" class="p-2">
              <div class="gallery-big">
                <img src="../assets/Images/landing/gallery5.jpg"/>
              </div>
            </v-col>
            <v-col md="6" sm="6" cols="12" class="p-2">
              <div class="gallery-big">
                <img src="../assets/Images/landing/gallery6.jpg"/>
              </div>
            </v-col>
          </v-row>
        </div> -->
      </div>
    </div>
    <div class="video-wrap-section py-16 mt-8">
      <div class="container">
        <div class="inner-page-wrap position-relative">
          <div class="video-part-area">
            <h3 class="common-head text-center">TP 360 Virtual Tour</h3>
          </div>
          <div class="video-web-hld position-relative">
            <!-- <a href="https://www.tp.edu.sg/vrtour/" target="_blank">
              <img src="../assets/Images/landing/v-tour.jpg"/>
            </a> -->

            <video
              id="vidbox_video"
              autoplay=""
              nocontrols=""
              muted=""
              loop=""
              preload=""
              class=""
            >
              <source
                src="https://www.tp.edu.sg/vrtour/res/content_video/Tp 360 Landing Page Video_v2_optimized.mp4"
                type="video/mp4"
              />
            </video>

            <div id="vidbox_container" class="">
              <div id="vidbox_container_txt" class="">
                <strong
                  >Get your TP experience anytime, anywhere,<br />
                  through our campus virtual tour today!</strong
                >
                <p>Create your tomorrow with us.</p>
                <div id="vidbox_explore_button" class="explore">
                  <a
                    href="https://www.tp.edu.sg/vrtour"
                    target="_blank"
                    @click="
                      AddEventAnalytics({
                        pageName: '/about',
                        action: 'click',
                        actionType: '',
                        actionLabel: 'EXPLORE_YOUR_FUTURE',
                      })
                    "
                    >EXPLORE YOUR FUTURE</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <PublicFooter></PublicFooter>
    </div>
  </div>
</template>

<script>
import PublicFooter from "@/components/PublicFooter.vue";
import { bus } from "@/main";
export default {
  name: "About",
  components: {
    PublicFooter,
  },
  metaInfo() {
    return {
      title: "World Youth Skills Day (Asia-Pacific) 2022",
      meta: [
        { property: "og:type", content: "website" },
        { name: "description", content: "ASIA-PACIFIC 2022" },
        {
          property: "og:title",
          content: "ASIA-PACIFIC 2022",
        },
        {
          property: "og:url",
          content: location.host,
        },
        { property: "og:type", content: "website" },
        {
          property: "og:description",
          content:
            "Significance of WYSD, celebrated at the UNEVOC level… and national level Some details of past editions of WYSD (at UNEVOC level) This is the first time that WYSD is celebrated at the regional level",
        },
        { property: "og:site_name", content: "Epiloge" },
        {
          property: "og:image",
          content:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT_C1647457916091E1647459328886%2FBranding%2F1200x628_1647965462226.png?alt=media&token=098e242f-7301-428b-80da-9afc9cebe25e",
        },
        {
          property: "twitter:card",
          content: "ASIA-PACIFIC 2022",
        },
        {
          property: "twitter:title",
          content: "ASIA-PACIFIC 2022",
        },
        {
          property: "twitter:description",
          content: "ASIA-PACIFIC 2022",
        },
        {
          property: "twitter:url",
          content: location.host,
        },
        {
          property: "twitter:description",
          content: "ASIA-PACIFIC 2022",
        },
        {
          property: "twitter:image",
          content:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT_C1647457916091E1647459328886%2FBranding%2F1200x628_1647965462226.png?alt=media&token=098e242f-7301-428b-80da-9afc9cebe25e",
        },
      ],
    };
  },
  mounted() {
    var data = {
      showUserWelcomeLoader: false,
    };

    bus.$emit("setUserWelcomeLoader", data);
    document.title = "About US";
  },
};
</script>
